<template>

<div class=" nav p-3 position-absolute " style="width: 100%; top: 0; left: 0; z-index: 10">
  <div class=" container d-flex justify-content-between align-items-center nav-padding">
    <ul class="d-flex align-items-center ">
      <li class="mr-md-2 mr-lg-4 pt-3"><a  class="text-white montserrat" href="https://www.sushihub.com.au/our-products/">Our Products</a></li>
      <li class="mr-md-2 mr-lg-4 pt-3"><a   class="text-white montserrat" href="https://www.sushihub.com.au/find-a-hub/ ">Find a Hub</a></li>
      <li class="mr-md-2 mr-lg-4 pt-3"><a  class="text-white montserrat" href=" https://www.sushihub.com.au/about-us/ ">About Us</a></li>
    </ul>

    <a href="/">  <img src="@/assets/images/sushiHub/sushiLogo.svg" alt="logo"></a>


    <ul class="d-flex align-items-center ">
      <li class="mr-md-2 mr-lg-4 pt-3"><a  class="text-white montserrat" href="https://www.sushihub.com.au/hub-events/ ">Hub Events</a></li>
      <li class="mr-md-2 mr-lg-4 pt-3"><a  class="text-white montserrat" href="https://www.sushihub.com.au/hub-news/ ">Hub News</a></li>
      <li class="mr-md-2 mr-lg-4 pt-3" style="cursor: pointer" @click="contactUs" ><a  class="text-white montserrat"  >Contact Us</a></li>
    </ul>
  </div>

<!--  <div>-->
<!--    <IntroHeaderMobile />-->
<!--  </div>-->

</div>

</template>

<script>
export default {
  name: "sushiNav",
  methods: {
    contactUs(){
      window.location.href=" https://www.sushihub.com.au/contact-us/ "
    }
  }
};

</script>

<style scoped>


.montserrat {
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}

.nav {
  background-color: #212121;


}

.nav-padding {
  padding: 0 10rem 0 10rem;
}

@media (max-width: 992px) {
  .nav-padding {
      padding: 0 0 0 0;
  }
}

</style>
